/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import { connect } from 'react-redux'
import {
  getAllGenericSportProperties,
  getSports,
} from '@sportninja/common/selectors/types'
import { SelectInput } from 'src/components/ts-components/SelectInput'
import { usePlayerContext } from '../../context/PlayerContext'
import { useCareerStats } from '../../hooks/useCareerStats'
import CareerStatsWidget from '../OverviewTab/CareerStatsWidget'
import DetailedStatsTable from './DetailedStatsTable'
import {
  getPlayerColumns,
  getGoalieColumns,
  getPlayerTitle,
  getGoalieTitle,
} from '../../utils/statColumns'

interface StatsTabProps {
  sports: any[]
  genericSports: any[]
}

const StatsTab = ({ sports, genericSports }: StatsTabProps) => {
  const { state } = usePlayerContext()
  const { player } = state

  const {
    selectedSport,
    setSelectedSport,
    selectOptions,
    filterOptionGroup,
    playerStats,
    goalieStats,
    allPlayerStats,
    allGoalieStats,
    statsLoading,
    isGenericSport,
    sportName,
  } = useCareerStats(player, sports, genericSports)

  const totalOptions = selectOptions.reduce(
    (sum, group) => sum + group.options.length,
    0
  )

  const playerColumns = getPlayerColumns(sportName, isGenericSport)
  const goalieColumns = getGoalieColumns(sportName)
  const playerTitle = getPlayerTitle(sportName, isGenericSport)
  const goalieTitle = getGoalieTitle(sportName)

  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        gap: 24px;
        margin-top: 24px;
      `}
    >
      {totalOptions > 1 && (
        <div
          css={css`
            display: flex;
            justify-content: flex-end;
          `}
        >
          <div
            css={css`
              min-width: 200px;
            `}
          >
            <SelectInput
              label=''
              name='sport'
              value={selectedSport || ''}
              options={selectOptions}
              filterOption={filterOptionGroup}
              disabled={false}
              onChange={(value: string) => {
                setSelectedSport(value)
              }}
              fieldErrors={[]}
              customError={{}}
              allowClear={false}
            />
          </div>
        </div>
      )}

      <CareerStatsWidget
        playerStats={playerStats}
        goalieStats={goalieStats}
        statsLoading={statsLoading}
        isGenericSport={isGenericSport}
        sportName={sportName}
      />

      {!statsLoading && allPlayerStats.length > 0 && (
        <DetailedStatsTable
          title={`${playerTitle} Statistics`}
          data={allPlayerStats}
          columns={playerColumns}
        />
      )}

      {!statsLoading && !isGenericSport && allGoalieStats.length > 0 && (
        <DetailedStatsTable
          title={`${goalieTitle} Statistics`}
          data={allGoalieStats}
          columns={goalieColumns}
        />
      )}
    </div>
  )
}

const mapStateToProps = (state: any) => ({
  sports: Object.values(getSports(state)),
  genericSports: getAllGenericSportProperties(state),
})

export default connect(mapStateToProps)(StatsTab)
